import useBellaCookies from './useBellaCookies';

export const KNOWN_CUSTOMER_COOKIE_NAME = 'user_is_known_by_entered_email';

const useIsKnownCustomer = (): [boolean, () => void] => {
    const [status, setStatus] = useBellaCookies(KNOWN_CUSTOMER_COOKIE_NAME, true);

    const isKnownCustomer = !!status;
    const setIsKnownCustomer = () => setStatus(1);

    return [isKnownCustomer, setIsKnownCustomer];
};

export default useIsKnownCustomer;
